import { render } from "./ReceiptRecord.vue?vue&type=template&id=5ca6bbc2&scoped=true"
import script from "./ReceiptRecord.vue?vue&type=script&lang=js"
export * from "./ReceiptRecord.vue?vue&type=script&lang=js"

import "./ReceiptRecord.vue?vue&type=style&index=0&id=5ca6bbc2&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca6bbc2"]])

export default __exports__